import { makeStyles, Theme } from '@material-ui/core/styles';
import React from 'react';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';

import { MapaOcorrencias } from './pages/mapa_ocorrencias/MapaOcorrencias';
 


const useStyles = makeStyles((theme: Theme) => ({
    root: {
        flexGrow: 1
    }
}));


export const Routers: React.FC = () => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <HashRouter >
                <Switch>
                    <Route exact path='/' render={() =>
                        <Redirect to='/home' />
                    } />
                   
                    <Route exact path='/home' render={() =>
                        <MapaOcorrencias />
                    } />
                </Switch>
            </HashRouter>
        </div>
    );
}